<soft-field-ok
  fieldOkName="ktostamm.kunde"
  placeholder="Kundenname oder Kundennummer"
  [title]="configuration()?.title ?? ''"
  [subtitle]="configuration()?.subtitle ?? ''"
  [parameters]="parameters()"
  [readonly]="readonly()"
  [value]="value()"
  (valueChange)="valueChange.emit($event)"
>
</soft-field-ok>
